import { Link } from "wouter";
import { Shield } from "lucide-react";

export function NavPublic() {
  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link href="/" className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-blue-600 rounded-full flex items-center justify-center">
                <Shield className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-gray-900">Smart Care Audits</span>
            </Link>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#solutions" className="text-gray-600 hover:text-gray-900 text-sm font-medium">
              Solutions
            </a>
            <a href="#pricing" className="text-gray-600 hover:text-gray-900 text-sm font-medium">
              Pricing
            </a>
            <a href="#templates" className="text-gray-600 hover:text-gray-900 text-sm font-medium">
              Resources
            </a>
            <a href="#about" className="text-gray-600 hover:text-gray-900 text-sm font-medium">
              About
            </a>
            <Link href="/login" className="text-purple-600 hover:text-purple-700 font-semibold text-sm" data-testid="link-sign-in">
              Sign in
            </Link>
          </div>

          {/* Mobile Sign in */}
          <div className="md:hidden">
            <Link href="/login" className="text-purple-600 hover:text-purple-700 font-semibold text-sm" data-testid="link-sign-in-mobile">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
